var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import RichTextEditor from "react-rte";
export var HTMLEditor = function (_a) {
    var html = _a.html, onChange = _a.onChange, disabled = _a.disabled, customControls = _a.customControls, inputRef = _a.inputRef, _b = _a.hideEditor, hideEditor = _b === void 0 ? false : _b;
    var _c = React.useState(RichTextEditor.createEmptyValue()), editorValue = _c[0], setEditorValue = _c[1];
    React.useEffect(function () {
        if (html !== editorValue.toString("html")) {
            setEditorValue(editorValue.setContentFromString(html, "html"));
        }
    }, [html, editorValue]);
    var handleChange = React.useCallback(function (newValue) {
        setEditorValue(newValue);
        onChange(newValue.toString("html"));
    }, [setEditorValue, onChange]);
    var toolbarConfig = {
        display: [
            "INLINE_STYLE_BUTTONS",
            "BLOCK_TYPE_BUTTONS",
            "LINK_BUTTONS",
            "BLOCK_TYPE_DROPDOWN",
            "HISTORY_BUTTONS",
        ],
        INLINE_STYLE_BUTTONS: [
            { label: "Bold", style: "BOLD" },
            { label: "Italic", style: "ITALIC" },
            { label: "Underline", style: "UNDERLINE" },
        ],
        BLOCK_TYPE_DROPDOWN: [
            { label: "Normal", style: "unstyled" },
            { label: "Heading Large", style: "header-one" },
            { label: "Heading Medium", style: "header-two" },
            { label: "Heading Small", style: "header-three" },
        ],
        BLOCK_TYPE_BUTTONS: [],
        BLOCK_ALIGNMENT_BUTTONS: [],
    };
    var disabledToolbarConfig = __assign({ extraProps: { isDisabled: true, disabled: true } }, toolbarConfig);
    var hideEditorStyle = {
        borderBottom: "none",
        borderBottomLeftRadius: "0px",
        borderBottomRightRadius: "0px",
    };
    return (React.createElement(RichTextEditor, { value: editorValue, onChange: handleChange, ref: inputRef, toolbarConfig: hideEditor ? disabledToolbarConfig : toolbarConfig, readOnly: disabled, customControls: customControls, editorStyle: { display: hideEditor ? "none" : "block" }, rootStyle: hideEditor ? hideEditorStyle : {} }));
};
